import { LitElement, html, css } from 'lit-element';
import dayjs from 'dayjs';
import { styleMap } from 'lit-html/directives/style-map.js';
import { actions, selectors } from './';
import { selectors as accountSelectors } from '../account';
import { connect } from '../store/connect';
import { AUTHORIZATIONS } from '../authorizations/authorizations';
import * as routeActions from './route-actions';
import '../routing/routed-button';
import { getRouter } from '../routing/route-base';
import { SELECT_MODES } from '../table/table-constants';
import { DETAIL_MODES } from '../form/constants';
import '@trumedianetworks/tmn-core-components/src/tmn-input';
import '@trumedianetworks/tmn-core-components/src/tmn-select';
import '@trumedianetworks/tmn-core-components/src/tmn-button';
import '@trumedianetworks/tmn-core-components/src/tmn-tooltip';
import '../table/tmn-table-searchable';
import './site-sport-context';
import '../table/tmn-table-editable';
import '../routing/routed-icon-button';
import './site-detail';
import '../util/loading-logo';

const { CAN_EDIT_SITES, CAN_EDIT_ROOT_SITES } = AUTHORIZATIONS;

const MULTI_SELECT_STATUS = {
    NONE: 'NONE',
    SOME: 'SOME',
    ALL: 'ALL',
};

const dateFormatFn = (value, row) => {
    return value
        ? html`${dayjs(value).format('YYYY-MM-DD')}`
        : html`<div style="text-align:center">-</div>`;
};

class SiteList extends LitElement {
    constructor() {
        super();
        this.allSites = [];
        //this.siteSports = sports.map((sport) => ({ displayKey: sport, name: sport }));
        // option to hide feature for now since backend isn't done yet.
        this.showMultiSelect = false;
    }

    static get styles() {
        return css`
            :host {
                --table-cell-height: 28px;
                display: flex;
                flex-direction: column;
            }
            tmn-select {
                min-width: 140px;
            }
            tmn-input {
                margin: 0;
            }

            .site-option-container {
                max-width: 400px;
            }

            .table-container {
                height: calc(100% - 45px);
            }
            .parent-chip {
                font-size: 14px;
                font-weight: 600;
                display: flex;
                flex-flow: row;
                flex-basis: auto;
                background-color: var(--light-gray-100);
                border-radius: 30px;
                padding: 4px 8px 4px 14px;
                align-items: center;
                border: 1px solid var(--app-primary-dark-color);
                align-self: flex-start;
                margin-top: 10px;
            }
            .parent-chip > routed-icon-button {
                margin-left: 8px;
                height: 34px;
                width: 34px;
            }
        `;
    }

    static get properties() {
        return {
            allSites: {
                type: Array,
            },
            _columnDefs: {
                type: Array,
            },
            selectedSiteNames: {
                type: Array,
            },
            detailMode: {
                type: String,
            },
            authorizations: {
                type: Array,
            },
            isActiveRecordDirty: {
                type: Boolean,
            },
            sport: {
                type: String,
            },
            isSiteAdminReady: {
                type: Boolean,
            },
            filterDefs: {
                type: Array,
            },
            parentSite: {
                type: String,
            },
            defaultParentSite: {
                type: String,
            },
            // or selected count and allselected?
            // multiSelectStatus: {
            //     type: String,
            // },
            // selectedRowsCount: {
            //     type: Number,
            // },
        };
    }

    firstUpdated() {
        // todo this?
        // const { authorizations } = this;
        // if (authorizations.includes(CAN_EDIT_SITES)) {
        //     this.actions.fetchSiteConfigTemplates();
        // }

        this._columnDefs = [
            {
                key: 'name',
                label: 'Name',
                sortable: true,
                search: true,
                // dataFormatter: (name, row) => {
                //     const sport = row.metaData.rawData.sport;
                //     const data = { site: name, sport };
                //     return html`<routed-link .data=${data} name="site-detail"
                //         >${name}</routed-link
                //     >`;
                // },
            },
            {
                key: 'domain',
                label: 'Domain',
                sortable: true,
                search: true,
                hideInDetailMode: true,
                dataFormatter: (domain, row) => {
                    return this.renderDomain(domain, row);
                },
            },
            {
                key: '_',
                label: 'Actions',
                hideInDetailMode: true,
                // dataFormatter: (name, row) => {
                //     const sport = row.data[3];
                //     const data = { parent: name, sport };
                //     return html`<routed-link .data=${data} name="child-sites"
                //         >child sites</routed-link
                //     >`;
                // },
                dataFormatter: (value, row) => {
                    return this.renderActions(row);
                },
            },
            {
                key: 'emailAccountDomain',
                label: 'Email Domain',
                sortable: true,
                search: true,
                hideInDetailMode: true,
            },
            {
                key: 'updated',
                label: 'Updated',
                sortable: true,
                hideInDetailMode: true,
                dataFormatter: dateFormatFn,
            },
            {
                key: 'active',
                label: 'Active',
                sortable: true,
                hideInDetailMode: true,
                dataFormatter: (value, row) => {
                    // todo sort out formatter options/styles, maybe do like tmn-table-render
                    // but see if there is a better technique now
                    const styles = {
                        textAlign: 'center',
                    };
                    let icon;
                    if (row?.metaData?.rawData?.softDeactivation) {
                        icon = 'do_not_disturb_on';
                        styles.color = '#f66308';
                    } else {
                        if (value) {
                            icon = 'check_circle_outline';
                            styles.color = 'var(--app-primary-color)';
                        } else {
                            icon = 'circle';
                            styles.color = 'rgba(0, 0, 0, 0.1)';
                        }
                    }
                    const iconStyle = styleMap(styles);
                    return html`<div style=${iconStyle}>
                        <tmn-icon icon=${icon} iconvariant="outlined"></tmn-icon>
                    </div>`;
                },
            },
        ];
    }

    updated(changedProps) {
        if (changedProps.has('parentSite')) {
            this.actions.fetchSiteList();
        }
    }

    render() {
        const { isSiteAdminReady } = this;
        if (!isSiteAdminReady) {
            return this.renderLoading();
        }
        return this.renderTable();
    }

    renderLoading() {
        return html`<loading-logo></loading-logo>`;
    }

    renderTable() {
        const {
            allSites,
            sport,
            selectedSiteNames,
            detailMode,
            isActiveRecordDirty,
            filterDefs,
            _columnDefs,
            authorizations,
            parentSite,
        } = this;
        const selectMode =
            detailMode === DETAIL_MODES.NEW ? SELECT_MODES.NONE : SELECT_MODES.SINGLE;
        const canAddNew = authorizations.includes(CAN_EDIT_SITES);
        return html`
            ${this.renderParentSite()}
            <div class="table-container">
                <tmn-table-editable
                    .canAddNew=${canAddNew}
                    @tmn-row-select-toggle=${this.handleRowSelectToggle}
                    @tmn-table-editable-add-new=${this.handleNewSite}
                    @tmn-table-editable-close-details=${this.handleCloseSite}
                    @tmn-table-selected-filter-data-changed=${this.handleSelectedFilterDataChanged}
                    .rowIdentifier=${'name'}
                    .filterDefs=${filterDefs}
                    .dataRows=${allSites}
                    .selectedRowIds=${selectedSiteNames}
                    .detailMode=${detailMode}
                    .selectMode=${selectMode}
                    .shouldConfirmOnClose=${isActiveRecordDirty}
                    .shouldConfirmOnNavigate=${isActiveRecordDirty}
                    .confirmMessage=${'The selected record appears to have changes.  If you continue without saving the changes will be lost.'}
                    .columnDefs=${_columnDefs}>
                    <div slot="left-actions"><site-sport-context></site-sport-context></div>
                    <site-detail slot="detail"></site-detail>
                </tmn-table-editable>
            </div>
        `;
    }

    renderParentSite() {
        const { parentSite, sport } = this;
        if (parentSite) {
            return html`<div class="parent-chip">
                Child sites for ${parentSite}
                <routed-icon-button name="site-list" .data=${{ sport }}
                    ><tmn-icon icon="clear" iconvariant="outlined" color="primary"></tmn-icon>
                </routed-icon-button>
            </div> `;
        }
    }

    handleNewSite(e) {
        const { sport, parentSite, authorizations, defaultParentSite } = this;
        if (!parentSite) {
            if (!authorizations.includes(CAN_EDIT_ROOT_SITES)) {
                if (defaultParentSite) {
                    routeActions.newSiteRoute(sport, defaultParentSite);
                } else {
                    // todo message?
                }
                return;
            }
        }
        routeActions.newSiteRoute(sport, parentSite);
    }

    handleCloseSite(e) {
        const { sport, parentSite } = this;
        routeActions.siteListRoute(sport, parentSite);
    }

    // note this is siteing the data in the table
    handleSelectedFilterDataChanged(e) {
        const { path, selectedValues } = e.detail;
        this.actions.setfilterDefsValue({ data: { path, value: selectedValues } });
    }

    handleRowSelectToggle(e) {
        const { sport, detailMode, parentSite } = this;
        if (detailMode === DETAIL_MODES.NEW) {
            return;
        }
        const { selected, id } = e.detail;
        const router = getRouter();
        if (selected) {
            routeActions.siteDetailRoute(sport, id, parentSite);
        } else {
            routeActions.siteListRoute(sport, parentSite);
        }
    }

    renderActions(row) {
        // could maybe make this more integrated so we wouldn't have to do stuff like this?
        const actionStyle = styleMap({
            whiteSpace: 'nowrap',
            position: 'relative',
        });
        const { metaData } = row;
        const childRouteData = {
            sport: metaData.rawData.sport,
            parent: metaData.rawData.authSiteName,
        };
        if (metaData.rawData.canAcceptChildSites) {
            return html`<div style=${actionStyle}>
                <tmn-tooltip selector="[name='child-sites']">Child sites</tmn-tooltip>
                <routed-icon-button name="child-site-list" .data=${childRouteData}
                    ><tmn-icon icon="view_list" iconvariant="outlined" color="primary"></tmn-icon>
                </routed-icon-button>
            </div>`;
        }
    }

    renderDomain(domain, row) {
        const domainStyle = styleMap({
            whiteSpace: 'nowrap',
            display: 'flex',
            //justifyContent: 'space-between',
            alignItems: 'center',
        });
        const anchorStyle = styleMap({
            marginRight: '8px',
        });
        const sport = row.metaData.rawData.sport;
        const url = `https://${domain}/${sport}`;
        return html`<div style=${domainStyle}>
            <a
                href=${url}
                target="_blank"
                @click=${this.handleExternalLinkClick}
                style=${anchorStyle}>
                <tmn-icon icon="launch" iconvariant="outlined"></tmn-icon
            ></a>
            ${domain}
        </div>`;
    }

    handleExternalLinkClick(e) {
        e.stopPropagation();
    }
}

const mapStateToProps = (state, ownProps) => {
    return (state) => {
        return {
            allSites: selectors.siteListTableSelector(state),
            selectedSiteNames: selectors.selectedSiteNamesSelector(state),
            detailMode: selectors.siteDetailModeSelector(state),
            isSiteAdminReady: selectors.isSiteAdminReadySelector(state),
            isActiveRecordDirty: selectors.isActiveRecordDirty(state),
            //filterDefs: selectors.filterDefsSelector(state),
            sport: selectors.siteSportSelector(state),
            authorizations: accountSelectors.accountAuthorizationsSelector(state),
            parentSite: selectors.selectedParentSiteSelector(state),
            defaultParentSite: selectors.defaultParentSiteSelector(state),
        };
    };
};

const combinedActions = {
    ...actions,
};
customElements.define('site-list', connect(mapStateToProps, combinedActions)(SiteList));
